import { render } from "./nothingCon.vue?vue&type=template&id=2f2d78fd&scoped=true"
const script = {}

import "./nothingCon.vue?vue&type=style&index=0&id=2f2d78fd&lang=scss&scoped=true"

import exportComponent from "/www/wwwroot/manga-official-website/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2f2d78fd"]])

export default __exports__